import jsPDF from 'jspdf';
import 'jspdf-autotable';

const generateClassTimetablePDF = (timetableData, linkedSessionTimes, days, classTitle) => {
  const doc = new jsPDF('landscape', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // ====== MAIN HEADER ======
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("ST. MARY'S JUNIOR SEMINARY - VISIGA", pageWidth / 2, 12, {
    align: "center",
  });

  doc.setFontSize(12);
  doc.text("CLASS TIMETABLE", pageWidth / 2, 18, {
    align: "center",
  });

  // ====== CLASS INFORMATION ======
  let y = 28;
  doc.setDrawColor(41, 128, 185);
  doc.setLineWidth(0.5);
  doc.line(15, y - 4, pageWidth - 15, y - 4);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("TIMETABLE INFORMATION", 15, y);

  y += 7;
  doc.setFontSize(10);

  const currentDate = new Date().toLocaleDateString();
  const info = [
    ["Class:", classTitle || "N/A"],
    ["Date Generated:", currentDate],
  ];

  info.forEach(([label, value]) => {
    doc.setFont("helvetica", "bold");
    doc.text(label, 20, y);
    doc.setFont("helvetica", "normal");
    doc.text(value || "N/A", 60, y);
    y += 6;
  });

  // ====== PREPARE TABLE DATA ======
  const headers = ["Day", ...linkedSessionTimes];
  
  const tableData = days.map((day) => {
    const row = [day];
    
    linkedSessionTimes.forEach((time) => {
      const cellDataArray = timetableData[day]?.[time];
      if (cellDataArray && Array.isArray(cellDataArray) && cellDataArray.length > 0) {
        // Handle multiple entries (multiple combinations) for the same session time
        const cellEntries = cellDataArray.map((cellData) => {
          if (cellData.subject && cellData.subject.trim() !== '') {
            // Has subject and teacher
            const subject = cellData.subject || '';
            const combination = cellData.combination ? ` (${cellData.combination})` : '';
            const teacher = cellData.teacher || '';
            return `${subject}${combination}\n${teacher}`;
          } else {
            // Break time, lunch time, prayer time, or any entry with null/empty subject
            return "Break Time";
          }
        });
        // Join multiple entries with double line break
        row.push(cellEntries.join('\n\n'));
      } else {
        // Empty cell (no assignment at all)
        row.push("-");
      }
    });
    
    return row;
  });

  // ====== TABLE ======
  doc.autoTable({
    head: [headers],
    body: tableData,
    startY: y + 8,
    margin: { left: 10, right: 10, top: 5, bottom: 20 },

    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: "linebreak",
      halign: "center",
      valign: "middle",
    },

    headStyles: {
      fillColor: [41, 128, 185],
      textColor: 255,
      fontStyle: "bold",
      fontSize: 8,
      halign: "center",
    },

    bodyStyles: {
      fontSize: 8,
      textColor: 0,
      halign: "center",
    },

    columnStyles: {
      0: { cellWidth: 25, fontStyle: "bold" }, // Day column
    },

    didDrawCell: (data) => {
      // Style break time cells
      if (data.section === 'body' && data.column.index > 0) {
        const cellValue = data.cell.text[0];
        if (cellValue && cellValue.includes('Break Time')) {
          doc.setFillColor(255, 245, 238); // Light orange background
          doc.setDrawColor(255, 200, 150);
          doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'FD');
          doc.setTextColor(200, 100, 50);
          doc.setFont("helvetica", "italic");
        } else if (cellValue && cellValue !== '-') {
          // Reset styles for normal cells
          doc.setTextColor(0, 0, 0);
          doc.setFont("helvetica", "normal");
        }
      }
    },
  });

  // ====== FOOTER ======
  const finalY = doc.lastAutoTable.finalY || y + 50;
  const pageCount = doc.internal.getNumberOfPages();

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(128, 128, 128);
    doc.text(
      `Page ${i} of ${pageCount}`,
      pageWidth / 2,
      pageHeight - 10,
      { align: "center" }
    );
  }

  // ====== SAVE PDF ======
  const fileName = `Class_Timetable_${classTitle || 'Timetable'}_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(fileName);
};

export default generateClassTimetablePDF;

